import { Pill } from '@iwoca/orion';
import clsx from 'clsx';
import { useSignupData } from 'components/Signup/hooks/useSignupData';
import sharedStyles from '../Guarantors.module.css';
import { DisabledGuarantorDetail } from './DisabledGuarantorDetail/DisabledGuarantorDetail';
import {
  formatDOB,
  formatResidentialAddresses,
  pluralize,
} from './DisabledGuarantors.helpers';
import styles from './DisabledGuarantors.module.css';

export const DisabledGuarantors = () => {
  const {
    state,
    stateData: { guarantors },
  } = useSignupData();

  if (!guarantors || guarantors.length === 0) {
    return null;
  }

  return (
    <div className={clsx(sharedStyles.container, styles.container)}>
      {guarantors.map((guarantor, index) => {
        // For reintroductions, show all the guarantor phone numbers (including ones added outside signup)
        const phoneNumbers =
          state?.application?.people
            ?.find((person) => person.uid === guarantor.uid)
            ?.phones?.map((phone) => phone.number)
            .filter(Boolean) || [];

        const address = guarantor.residentialAddresses?.length
          ? formatResidentialAddresses(guarantor.residentialAddresses).map(
              ({ formattedAddress, residentialStatus }, index) => (
                <div className={styles.address} key={formattedAddress + index}>
                  <div className={styles.addressHeader}>{formattedAddress}</div>
                  <div className={styles.addressFooter}>
                    • <span>{residentialStatus}</span>
                  </div>
                </div>
              ),
            )
          : null;

        return (
          <section key={index} className={sharedStyles.fieldContainer}>
            {index > 0 && <hr className={sharedStyles.seperator} />}
            <h2 className={styles.heading}>Contact {index + 1}</h2>

            {guarantor.roles && guarantor.roles?.length > 0 && (
              <div className={styles.guarantorRoles}>
                {guarantor.roles.map((role) => (
                  <Pill key={role}>{role}</Pill>
                ))}
              </div>
            )}

            <div className={styles.fields}>
              <DisabledGuarantorDetail
                label="Name"
                value={`${guarantor.firstName} ${guarantor.lastName}`}
              />

              <DisabledGuarantorDetail
                label="Date of birth"
                value={formatDOB(
                  guarantor.dobDay,
                  guarantor.dobMonth,
                  guarantor.dobYear,
                )}
              />

              <DisabledGuarantorDetail
                label={pluralize('Mobile phone number', phoneNumbers.length)}
                value={phoneNumbers.join(', ')}
              />

              <DisabledGuarantorDetail
                label="Direct email address"
                value={guarantor.email}
              />

              <DisabledGuarantorDetail
                label={pluralize(
                  'Address',
                  guarantor.residentialAddresses?.length,
                )}
                value={address}
              />
            </div>
          </section>
        );
      })}
    </div>
  );
};
